// extracted by mini-css-extract-plugin
export default {"terms":"terms_terms__3Rl+h"};